import React from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../config";
import LottieAnimation from "../LottieAnimation";
import PaymentFailed from "../../Payment_Failed.json";

const Cancel = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [value, setValue] = React.useState(true);

  const callApi = async () => {
    setValue(true);
    const id = queryParams.get("id");
    console.log("id :::", id);

    const data = {
      historyId: id,
    };

    await axios(`${API_URL}/api/history/add-money-declines`, {
      method: "POST",
      credentials: "include",
      data: data,
    });
    setValue(false);
  };

  React.useEffect(() => {
    console.log("Cancel...");
    callApi();
    setValue(false);
  }, []);

  return (
    <div>
      {value ? <LottieAnimation animationData={PaymentFailed} /> : Cancel}
    </div>
  );
};

export default Cancel;
